import { Button, Table } from "@mantine/core";
import { TrProps } from "../../../types/types";
import { IconDownload } from "@tabler/icons-react";
import { useState } from "react";
import ButtonColumn from "../ButtonColumn/ButtonColumn";

// todo: Bring in type prop so we know what buttons to display
export default function TableRow<T extends Record<string, any>>(
  props: TrProps<T>
) {
  const { row, headers } = props;

  // Array that stores all of the header names that are used to display buttons instead of text.
  // If the header is in the array, handleButton will be called instead of displaying the text.
  const buttonHeaders: string[] = ["Download", "Details", "Button"];
  return (
    <Table.Tr>
      {headers.map((header) => <Table.Td key={String(header.displayName)}>{row[header.key]}</Table.Td>
      )}
      {props.type !== "cards" ?
        (<Table.Td key={"Action"}> <ButtonColumn row={props.row} type={props.type} /> </Table.Td>)
        : (null)
      }
    </Table.Tr>
  );
}
